var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodoReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "32px",
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bells") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B_\\u5DE5\\u4F5C\\u53F0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-361.000000, -115.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F85\\u529E\\u63D0\\u9192",
    transform: "translate(346.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,42.9032258 C33.9141265,42.9032258 34.6551724,43.5964623 34.6551724,44.4516129 C34.6551724,45.3067635 33.9141265,46 33,46 L28.0344828,46 C27.1203563,46 26.3793103,45.3067635 26.3793103,44.4516129 C26.3793103,43.5964623 27.1203563,42.9032258 28.0344828,42.9032258 L33,42.9032258 L33,42.9032258 Z M30,14 C30.9711433,14 31.8019923,14.6882351 31.97,15.6320304 C36.8293096,16.5141763 40.4798471,20.5106036 40.866,25.3709298 L41.844,37.6812144 L43.4,37.6812144 C44.2836556,37.6812144 45,38.3880438 45,39.259962 C45,40.1318803 44.2836556,40.8387097 43.4,40.8387097 L16.6000001,40.8387097 C16.0283751,40.8387097 15.5001719,40.5378021 15.2143594,40.0493359 C14.9285469,39.5608697 14.9285469,38.9590544 15.2143594,38.4705882 C15.5001719,37.982122 16.0283751,37.6812144 16.6000001,37.6812144 L18.1560001,37.679241 L19.1340001,25.3709298 C19.5203712,20.5099988 23.1719036,16.5133809 28.032,15.6320304 C28.199125,14.6885412 29.0293147,14 30,14 Z M25.0501242,27.4215987 C24.3463199,27.381575 23.7218743,27.8810856 23.5880194,28.5911749 L23.5638524,28.7874819 L23.2758621,34.1518281 L23.2798899,34.348135 C23.3369992,35.0688672 23.9040649,35.6355996 24.607755,35.6752197 C25.311445,35.7148398 25.935542,35.2151738 26.0691669,34.5051806 L26.09132,34.31094 L26.3793103,28.9465939 L26.3772964,28.7502869 C26.3208535,28.028441 25.7528598,27.4606601 25.0481103,27.4215987 L25.0501242,27.4215987 Z",
    id: "bells"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoReminder);
export default __webpack_public_path__ + "static/media/todo-reminder.997135ee.svg";
export { ForwardRef as ReactComponent };